import { Link, useParams } from 'react-router-dom';
import More from '../../../../../../Components/Icons/More';
import { Modal, notification } from 'antd';
import axiosInstance from '../../../../../../Services/axiosCommon';
import { ExclamationCircleFilled } from "@ant-design/icons";
import { GetAccess } from '../../../../../../Components/Utils/roles';
import ViewIcon from '../../../../../../Components/Icons/ViewIcon';
import EditIcon from '../../../../../../Components/Icons/Edit';
import DeleteIcon from '../../../../../../Components/Icons/Delete';

import { useState } from 'react';

import ViewMaterial from './ViewMaterial';
import EditMaterial from './EditMaterial';


const {confirm} = Modal


const ViewMore = ({ data,getData,id,Category,Division,Unit,Item,itemsCategory,Activity}) => {
  const {officeId,projectId} = useParams()
  const [api, contextHolder] = notification.useNotification();
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
 
 

  const handleDelete = async (id, removevalue) => {
    // console.log('====================================');
    // console.log(removevalue,"lll");
    // console.log('====================================');
    confirm({
      title: `Do you Want to delete ${removevalue}?`,
      centered: true,
      icon: <ExclamationCircleFilled />,
      content: `The ${removevalue} will be removed from the Material List`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        axiosInstance.delete(`/material/${data.materialId}`).then((response) => {
            if (response.data?.status == true) {
              api.success({
                message: `${removevalue}  Deleted successfully`,
                materialId:response?.data?.msg||' ',
                placement: "bottomRight",
              });
              getData();
            } else {
              api.error({
                message: `${removevalue} Deleted failed`,
                materialId: response?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((error) => {
            api.error({
              message: `Project Costing  Deleted failed`,
              materialId: error?.response?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
          });
      },
      onCancel() {},
    });
  };


  return (
    <>
        {contextHolder}
        <div className="text-[#344767]  relative dropdown inline-block z-1 group">
        <div className=" cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-left">
          <span className=" w-7 h-7 bg-gray-50 flex flex-col items-center   justify-center rounded-full">
            <More />
          </span>
        </div>
        <ul className="dropdown-menuOne  text-[#344767] text-left  rounded-lg absolute -left-[80px] -top-3 overflow-hidden hidden  z-50 shadow-lg  group-hover:block">
           {/* <li className=' w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              // onClick={() => setOpen(true)}
            >
              <Link className=' text-black hover:text-black' to={`/item/teamandcondition/view/${id}`} state={{ data: data }} >View</Link>
            </span>
          </li> */}
           <li className="w-[100px] bg-black block m-0">
            <span
              className="bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium"
              onClick={() => setViewOpen(true)}
            >
              View
            </span>
          </li>
          {GetAccess(true) && (
            <li className=" w-[100px] bg-black block m-0">
              <span
                className="bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                onClick={() => setOpen(true)}
              >
                Edit
              </span>
            </li>
          )}
          {GetAccess(true) && (
            <li className=" w-[100px] bg-black block m-0">
              <span
                className="bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                onClick={() => {
                  handleDelete(data.id, data?.item);
                }}
              >
                Delete
              </span>
            </li>
          )}
        </ul>
      </div>
      <EditMaterial
        data={data}
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        getData={getData}
        projectId={projectId}
        id={id}
        Category={Category}
        Unit={Unit}
        Division={Division}
        Item={Item}
        itemsCategory={itemsCategory}
        Activity={Activity}
      />
      <Modal
        open={viewOpen}
        onCancel={() => setViewOpen(false)}
        title={"View Material Item"}
        width="50%"
        centered
        className="my-modal"
        footer={[]}
      >
        <ViewMaterial
          data={data}
          open={viewOpen}
          onCancel={() => setViewOpen(false)}
        />
      </Modal>

      {/* <div className='w-full flex justify-between items-center'>
        <div>  <Link
              
             to={`/project/costing/man-power/${officeId}/${projectId}/view/${id}`} state={{data:data}}><ViewIcon color="#048178" /></Link>              
        </div>
        <div>   
        <Link 
              to={`/project/costing/man-power/${officeId}/${projectId}/edit/${id}`} state={{data:data}}><EditIcon color="skyblue" width={"12"} height={"12"} /></Link>             
        </div>
        <div>     
        <a
                
                to='#'
                onClick={() => {
                  handleDelete(id,` ${data?.id||""} ${data?.serial_number||""}`);
                }}
              >
                <DeleteIcon height={"3"} width={"3"} color="lightcoral" />
              </a>                 
        </div>

      </div> */}


    </>
  );
};

export default ViewMore;
